import RouterContainer from './src/router-container';

export default RouterContainer;
